<template>
  <div
    class="insights-rankings-widget"
  >
    <InsightsRankingWidget
      v-if="!isAllMembersDashboard"
      label="Projects"
      :widget-key="projects"
      type="list"
      :limit="limit"
    />
    <InsightsRankingWidget
      v-if="!isAllMembersDashboard"
      label="Tasks"
      :widget-key="tasks"
      type="list"
      :limit="limit"
    />
    <InsightsRankingWidget
      label="Categories"
      :widget-key="categories"
      type="list"
      :limit="limit"
      tooltip="Apps & URLs are grouped into categories."
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { INSIGHTS } from '~/app_constants';
import InsightsRankingWidget from '~/components/insights/InsightsRankingWidget.vue';

export default {
  name: 'InsightsRankingsWidget',
  components: {
    InsightsRankingWidget,
  },
  data: () => ({
    categories: INSIGHTS.api.ranking.categories,
    tasks: INSIGHTS.api.ranking.tasks,
    projects: INSIGHTS.api.ranking.projects,
  }),
  computed: {
    ...mapGetters(['isAllMembersDashboard']),
    limit() {
      return INSIGHTS.parameters.rankingLimit;
    },
  },
};
</script>
